import { gql } from 'apollo-boost';

export const MINIMAL_SEARCH_QUERY = gql`
query search($types: [ES_SearchOptionsTypesEnum!], $query: String, $page: Int, $limit: Int, $sort: ES_SearchOptionsSortEnum, $order: ES_SearchOptionsOrderEnum, $personId: UUID, $localeCode: ES_SearchOptionsLocaleCodeEnum, $categoryId: UUID, $ids: [UUID!]) {
  search(searchOptions: {types: $types, query: $query, page: $page, limit: $limit, sort: $sort, order: $order, personId: $personId, localeCode: $localeCode, categoryId: $categoryId, _ids: $ids, isPublished: true}) {
    totalCount
      searchOptions {
        page
        limit
      }
      edges {
        node {
          __typename
          ... on ES_Curriculum {
            curriculumId
            name {
              locale
              content
            }
            description {
              locale
              content
            }
          }
          ... on ES_Course {
            courseId
            name {
              locale
              content
            }
            description {
              locale
              content
            }
            learningObjects {
              duration
            }
          }
          ... on ES_Resource {
            resourceId
            name {
              locale
              content
            }
          }
          ... on ES_Notification {
            notificationId
            name {
              locale
              content
            }
          }
        }
      }
    }
  }
`;